import { render, staticRenderFns } from "./TaskDueDatePopover.vue?vue&type=template&id=2e87b968&scoped=true"
import script from "./TaskDueDatePopover.vue?vue&type=script&lang=ts"
export * from "./TaskDueDatePopover.vue?vue&type=script&lang=ts"
import style0 from "./TaskDueDatePopover.vue?vue&type=style&index=0&id=2e87b968&prod&lang=scss&scoped=true"
import style1 from "./TaskDueDatePopover.vue?vue&type=style&index=1&id=2e87b968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e87b968",
  null
  
)

export default component.exports